const validate = (values) => {
  const attrs = values || {};
  const errors = {};
  if (!attrs.email) {
    errors.email = 'Debe ingresar el correo electrónico.';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(attrs.email)) {
    errors.email = 'El correo electronico no es valido.';
  }
  if (!attrs.password) {
    errors.password = 'Debe ingresar la contraseña actual';
  }
  if (!attrs.newPassword) {
    errors.newPassword = 'Debe ingresar la nueva contraseña';
  }
  if (attrs.newPassword && attrs.newPasswordConfirmation === attrs.password) {
    errors.newPassword = 'La nueva contraseña no puede ser igual a la contraseña actual';
  }
  if (!attrs.newPasswordConfirmation) {
    errors.newPasswordConfirmation = 'Debe confirmar la nueva contraseña';
  }
  if (attrs.newPasswordConfirmation && attrs.newPasswordConfirmation !== attrs.newPassword) {
    errors.newPasswordConfirmation = 'La confirmación de la nueva contraseña no es igual a la nueva contraseña';
  }
  errors.isValid = Object.keys(errors).length === 0;

  return errors;
};

export default validate;
